import { render, staticRenderFns } from "./LomInformation.vue?vue&type=template&id=5ff18189"
import script from "./LomInformation.vue?vue&type=script&lang=js"
export * from "./LomInformation.vue?vue&type=script&lang=js"
import style0 from "./LomInformation.vue?vue&type=style&index=0&id=5ff18189&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports